import React, {useContext, useState} from 'react';
import './ModalNewUser.css'
import {Context} from "../../index";
import {createChatAndMsg} from "../../http/ChatAPI";

const ModalAddChatUser = ({acshow, setAcshow, allUsers, setExecutor, executor}) => {

    const {userStore} = useContext(Context)
    const [txtNewChat, setTxtNewChat] =useState('')

    const newChatMessage = (firstSocketId, secondSocketId, message) => {
        createChatAndMsg(firstSocketId, secondSocketId, message)
        setTxtNewChat('')
        setAcshow(false)
    }

    return (
        <div className={acshow ? "modal active" : "modal"} onClick={() => setAcshow(false)}>
            <div className={acshow ? "modal__content active" : "modal__content"} onClick={e => e.stopPropagation()}>

                <h4>Выберите пользователя и напишите сообщение</h4>
                <div className="new__chat__block">
                    <div className="select-style">
                        <select onChange={e => setExecutor(e.target.value)} value={executor}
                                className="select__css select__css__chat">
                            <option>Выбор...</option>
                            {allUsers.filter(item => item.id !== userStore.user.id && item.block === false)
                                .sort(({id: previoudID}, {id: currentID}) => previoudID - currentID)
                                .map(users =>
                                    <option
                                        onClick={() => setExecutor(users)}
                                        key={users.id}
                                        value={users.socketId}
                                    >
                                        {users.firstName} {users.secondName}
                                    </option>
                                )}
                        </select>
                    </div>

                    <textarea value={txtNewChat} onChange={e => setTxtNewChat(e.target.value)} className="txt__new__chat" placeholder="Напишите сообщение..."></textarea>
                    {!executor || executor === "Выбор..." || txtNewChat === ''
                        ?
                        null
                        : <div>
                            <button
                                className='btn__yes__chat'
                                onClick={() => newChatMessage(userStore.user.socketId, executor, txtNewChat)}
                            >
                                Отправить
                            </button>
                        </div>

                    }

                </div>

                <div className="cl__add__chat__block">
                    <div className="cl-btn-6" onClick={() => setAcshow(false)}>
                        <div className="cl-btn-6-in">
                            <div className="cl-btn-6-txt">Закрыть</div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default ModalAddChatUser;